import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { ImageDescriptionSlideoutItemType } from '@application/Types/ComponentTypes'

import { ImageWrapper, Subtitle, Title, Wrapper } from './ImageDescriptionSlideoutItem.styled'

export type MemberProps = ImageDescriptionSlideoutItemType & {
    className?: string
}

export const ImageDescriptionSlideoutItem = ({
    title,
    subtitle,
    image,
    className,
    imageAnimation,
}: MemberProps): JSX.Element => {
    const WrapperTilt = imageAnimation ? Tilt : React.Fragment
    return (
        <Wrapper className={className}>
            <WrapperTilt>
                <ImageWrapper>{image && <Image image={image} />}</ImageWrapper>
            </WrapperTilt>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
        </Wrapper>
    )
}
